<template>
  <div class="car-brand-page">
    <header class="heading"><h2>汽车品牌</h2><div class="actions">
      <el-button :icon="Download" :loading="exporting" @click="exportRows">导出</el-button>
      <el-button type="primary" :icon="Plus" @click="edit()">新增品牌</el-button>
    </div></header>
    <el-form inline class="filters" @submit.prevent="search">
      <el-form-item label="品牌名称"><el-input v-model="query.brandName" clearable maxlength="100" @keyup.enter="search" /></el-form-item>
      <el-form-item label="品牌编码"><el-input v-model="query.brandCode" clearable maxlength="64" @keyup.enter="search" /></el-form-item>
      <el-form-item label="首字母"><el-select v-model="query.firstLetter" clearable style="width: 100px"><el-option v-for="letter in letters" :key="letter" :value="letter" :label="letter" /></el-select></el-form-item>
      <el-form-item label="状态"><el-select v-model="query.status" clearable style="width: 110px"><el-option :value="1" label="启用" /><el-option :value="0" label="停用" /></el-select></el-form-item>
      <el-form-item><el-button :icon="Search" type="primary" @click="search">查询</el-button><el-button :icon="Refresh" @click="reset">重置</el-button></el-form-item>
    </el-form>
    <div class="table-tools"><span>共 {{ total }} 条，已选择 {{ selected.length }} 条</span><el-button type="danger" plain :icon="Delete" :disabled="!selected.length || busy" @click="remove(selected)">批量删除</el-button></div>
    <el-table ref="table" :data="rows" row-key="id" border v-loading="loading" @selection-change="items => selected = items.map(item => item.id)">
      <el-table-column type="selection" width="48" :selectable="row => row.isDefault !== 1" />
      <el-table-column label="Logo" width="85" align="center"><template #default="{ row }"><el-image v-if="row.logoUrl" :src="row.logoUrl" :preview-src-list="[row.logoUrl]" preview-teleported fit="contain" class="brand-logo"><template #error><span class="muted">无图片</span></template></el-image><span v-else>--</span></template></el-table-column>
      <el-table-column prop="brandName" label="品牌名称" min-width="150" show-overflow-tooltip />
      <el-table-column prop="brandCode" label="品牌编码" min-width="130" show-overflow-tooltip />
      <el-table-column prop="firstLetter" label="首字母" width="80" align="center" />
      <el-table-column prop="sort" label="排序" width="70" align="center" />
      <el-table-column label="默认品牌" width="95" align="center"><template #default="{ row }"><el-tag :type="row.isDefault === 1 ? 'success' : 'info'">{{ row.isDefault === 1 ? '是' : '否' }}</el-tag></template></el-table-column>
      <el-table-column label="状态" width="85" align="center"><template #default="{ row }"><el-tag :type="row.status === 1 ? 'success' : 'info'">{{ row.status === 1 ? '启用' : '停用' }}</el-tag></template></el-table-column>
      <el-table-column prop="updateBy" label="操作人" min-width="100" show-overflow-tooltip />
      <el-table-column prop="createTime" label="创建时间" min-width="175" />
      <el-table-column label="操作" fixed="right" width="165"><template #default="{ row }"><el-button link type="primary" :icon="Edit" @click="edit(row)">编辑</el-button><el-button link type="danger" :icon="Delete" :disabled="row.isDefault === 1 || busy" @click="remove([row.id])">删除</el-button></template></el-table-column>
      <template #empty><el-empty description="暂无汽车品牌" /></template>
    </el-table>
    <el-pagination class="pagination" v-model:current-page="query.current" v-model:page-size="query.size" :page-sizes="[10, 20, 50, 100]" :total="total" layout="total, sizes, prev, pager, next" @size-change="search" @current-change="load" />
    <el-dialog v-model="visible" :title="editingId ? '编辑汽车品牌' : '新增汽车品牌'" width="min(600px, 94vw)" :close-on-click-modal="false" :before-close="close">
      <el-form ref="form" :model="body" :rules="rules" label-width="95px" :disabled="busy || uploading">
        <el-form-item label="品牌名称" prop="brandName"><el-input v-model="body.brandName" maxlength="100" /></el-form-item>
        <el-form-item label="品牌编码" prop="brandCode"><el-input v-model="body.brandCode" maxlength="64" @input="fillLetter" /></el-form-item>
        <el-form-item label="首字母" prop="firstLetter"><el-select v-model="body.firstLetter"><el-option v-for="letter in letters" :key="letter" :value="letter" :label="letter" /></el-select></el-form-item>
        <el-form-item label="Logo" prop="logoUrl"><div class="logo-editor"><el-image v-if="body.logoUrl" :src="body.logoUrl" fit="contain" class="logo-preview" /><el-upload :show-file-list="false" accept="image/png,image/jpeg" :http-request="upload" :disabled="uploading || busy"><el-button :icon="Upload" :loading="uploading">上传Logo</el-button></el-upload><el-input v-model="body.logoUrl" maxlength="1000" placeholder="https://..." aria-label="Logo地址" /></div></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="body.sort" :min="0" :max="9999" /></el-form-item>
        <el-form-item label="启用"><el-switch v-model="body.status" :active-value="1" :inactive-value="0" /></el-form-item>
        <el-form-item label="默认品牌"><el-switch v-model="body.isDefault" :active-value="1" :inactive-value="0" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="body.remark" type="textarea" :rows="2" maxlength="500" show-word-limit /></el-form-item>
      </el-form>
      <template #footer><el-button :disabled="busy || uploading" @click="visible = false">取消</el-button><el-button type="primary" :loading="busy" :disabled="uploading" @click="save">保存</el-button></template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, nextTick, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Plus, Edit, Delete, Download, Upload, Search, Refresh } from '@element-plus/icons-vue';
import { listCarBrands, saveCarBrand, deleteCarBrands, uploadCarBrandLogo, exportCarBrands } from '@/api/carBrand';

const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
const query = reactive({ current: 1, size: 10, brandName: '', brandCode: '', firstLetter: '', status: '' });
const rows = ref([]), total = ref(0), selected = ref([]), table = ref(), form = ref();
const loading = ref(false), busy = ref(false), uploading = ref(false), exporting = ref(false), visible = ref(false), editingId = ref(null);
const defaults = () => ({ brandName: '', brandCode: '', firstLetter: '', logoUrl: '', sort: 0, status: 1, isDefault: 0, remark: '' });
const body = reactive(defaults());
const rules = {
  brandName: [{ required: true, whitespace: true, message: '请输入品牌名称', trigger: 'blur' }],
  brandCode: [{ required: true, pattern: /^[A-Za-z0-9_-]{1,64}$/, message: '编码只能使用字母、数字、下划线或横杠', trigger: 'blur' }],
  firstLetter: [{ required: true, message: '请选择首字母', trigger: 'change' }],
  logoUrl: [{ required: true, pattern: /^https?:\/\//i, message: '请上传Logo或填写HTTP(S)图片地址', trigger: 'blur' }],
};
const error = err => { if (!err?.reported) ElMessage.error(err?.message || '操作失败，请重试'); };
const params = () => Object.fromEntries(Object.entries(query).filter(([, value]) => value !== '' && value != null));
let requestId = 0;
async function load() {
  const id = ++requestId;
  loading.value = true;
  try {
    const page = await listCarBrands(params());
    if (id !== requestId) return;
    rows.value = page.records || []; total.value = page.total || 0; selected.value = [];
    await nextTick(); table.value?.clearSelection();
  } catch (err) { if (id === requestId) error(err); }
  finally { if (id === requestId) loading.value = false; }
}
function search() { query.current = 1; load(); }
function reset() { Object.assign(query, { current: 1, brandName: '', brandCode: '', firstLetter: '', status: '' }); load(); }
async function edit(row) {
  editingId.value = row?.id || null;
  const initial = defaults();
  Object.keys(initial).forEach(key => { body[key] = row?.[key] ?? initial[key]; });
  visible.value = true;
  await nextTick(); form.value?.clearValidate();
}
function fillLetter(value) { if (!body.firstLetter && /^[A-Za-z]/.test(value)) body.firstLetter = value[0].toUpperCase(); }
function close(done) { if (!busy.value && !uploading.value) done(); }
async function save() {
  if (busy.value || uploading.value || !(await form.value.validate().catch(() => false))) return;
  if (body.isDefault === 1 && body.status !== 1) { ElMessage.warning('默认品牌必须启用'); return; }
  busy.value = true;
  try { await saveCarBrand(editingId.value, { ...body }); visible.value = false; ElMessage.success('保存成功'); await load(); }
  catch (err) { error(err); } finally { busy.value = false; }
}
async function upload({ file }) {
  if (!['image/png', 'image/jpeg'].includes(file.type) || file.size > 2 * 1024 * 1024) { ElMessage.warning('请选择2MB以内的PNG或JPG图片'); return; }
  uploading.value = true;
  try { body.logoUrl = await uploadCarBrandLogo(file); form.value?.clearValidate('logoUrl'); }
  catch (err) { error(err); } finally { uploading.value = false; }
}
async function remove(ids) {
  try { await ElMessageBox.confirm(`确认删除这 ${ids.length} 条汽车品牌？`, '删除确认', { type: 'warning', confirmButtonText: '删除', cancelButtonText: '取消' }); }
  catch { return; }
  busy.value = true;
  try { await deleteCarBrands(ids); ElMessage.success('删除成功'); if (query.current > 1 && ids.length === rows.value.length) query.current--; await load(); }
  catch (err) { error(err); } finally { busy.value = false; }
}
async function exportRows() {
  exporting.value = true;
  try {
    const blob = await exportCarBrands(params());
    const url = URL.createObjectURL(blob), link = document.createElement('a');
    link.href = url; link.download = '汽车品牌.csv'; link.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (err) { error(err); } finally { exporting.value = false; }
}
onMounted(load);
</script>

<style scoped>
.car-brand-page { padding: 20px; background: #fff; min-width: 0; }
.heading, .table-tools, .actions { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; }
.heading { margin-bottom: 20px; } h2 { font-size: 20px; margin: 0; }
.filters { padding-bottom: 6px; border-bottom: 1px solid #e5e7eb; }
.filters :deep(.el-input) { width: 170px; }
.table-tools { margin: 14px 0; color: #606266; font-size: 14px; }
.brand-logo { width: 48px; height: 48px; vertical-align: middle; }
.logo-preview { width: 76px; height: 76px; }
.logo-editor { display: flex; flex-wrap: wrap; gap: 12px; align-items: center; width: 100%; }
.logo-editor .el-input { flex-basis: 100%; }
.pagination { margin-top: 18px; overflow-x: auto; } .muted { font-size: 12px; color: #909399; }
@media (max-width: 600px) { .car-brand-page { padding: 12px; } }
</style>
